import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogGalleryComponent } from "../dialog-gallery/dialog-gallery.component";
import { MatDialog } from "@angular/material/dialog";
export interface imageItem {
  indexImage: number;
  urlImage: string;
}
@Component({
  selector: "app-slider-image",
  templateUrl: "./slider-image.component.html",
  styleUrls: ["./slider-image.component.css"],
})
export class SliderImageComponent implements OnInit {
  constructor(public dialog: MatDialog) { }
  @Input() images!: any;
  @Input() indexImg!: number;
  // @Output() changeImageIndex = new EventEmitter<{ _imgIndex: number }>();

  _imageList!: imageItem[];
  // _index: number = 0;
  length!: number;
  _minIndex: number = 0;
  _maxIndex: number = 6;

  // mainImg!: string;
  mainImg!: string;

  ngOnInit(): void {

    // 
    this.mainImg = this.images[0].image_url;

    if (this.images.length) {
      this._imageList = this.images.map((_img: any, index: number) => {
        return {
          indexImage: index,
          urlImage: _img.image_url,
        };
      });

      const __length = this._imageList.length;
      this.length = __length;
      if (__length <= 6) {
        this._maxIndex = __length;
      } else {
        this._maxIndex = 6;
      }
    }
  }

  fnBack() {
    if (this._minIndex > 0) {
      this._minIndex = this._minIndex - 1;
      this._maxIndex = this._maxIndex - 1;
    }
  }

  fnNext() {
    if (this._maxIndex < this.length) {
      this._minIndex = this._minIndex + 1;
      this._maxIndex = this._maxIndex + 1;
    }
  }
  fnShow(i: number) {
    this.indexImg = i;
    this.mainImg = this._imageList[this.indexImg].urlImage;
  }

  fnZoom(urlImage: string) {
    const dialogRef = this.dialog.open(DialogGalleryComponent, {
      data: { urlImage: urlImage },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}

